jQuery(function($){

	let onclickParent = '.block-editor, .sc-field-editor';

	//===============================
	// Expand Array Field Groups
	//===============================

	//Expand on click
	$(onclickParent).on('click', '.field.array .array-field-group .header', function(e){
		e.stopPropagation();
		if(!$(this).closest('.array-field-group').hasClass('default-value') && !$(this).closest('.array-field-group').hasClass('predefined-no-values')) {
			$(this).closest('.array-field-group').toggleClass('expanded');
		}
	});

	//Do not expand if order number is clicked
	$(onclickParent).on('click', '.field.array .array-field-group .header .order-number', function(e){
		e.stopPropagation();
	});



	//===============================
	// Add/Remove Array Field Groups 
	//===============================

	//Add Button
	$(onclickParent).on('click', '.field.array .select-popup-button.add', function(event){
		console.log('clicked');
		event.stopPropagation();

		let el = $(this);
		el.after('<div class="updating"><div class="loading-icon"></div> Updating...</div>');

		let data = {
			action: 'sc_field_editor_add_array_field_group',
			i: el.closest('.field.array').find('.array-field-group[parent="' + el.attr('field_name') + '"]:not(.default-value)').length,
			post_id: el.attr('post_id'),
			field: el.attr('field'),
			field_info: el.attr('field_info'),
			field_name: el.attr('field_name')
		};

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			const selector = '.sortable[full_field_name="' + el.attr('field_name') + '"]';
			console.log(selector);
			el.closest('.field.array').find(selector).append(response);
			console.log(el.closest('.field.array'));
			el.closest('.field.array').find('.color-picker-input').each(function(){
				console.log($(this));
				$(this).iris({
					hide: false,
					change: function(event, ui) {
						let parentDiv = event.target.closest('.color-picker');
						let display = $(parentDiv).find('.color-picker-display');
						display.css('background', ui.color.toString()).html('<span>' + ui.color.toString() + '</span>').show();
					}
				});
			});
			el.closest('.field.array').find('input').first().trigger('change');
			el.closest('.field.array').find('.updating').remove();
			el.closest('.field.array').find('.add-new').each(function(){
				setRequired($(this), false);
			});
			const parentId = el.closest('.field.array').find('.sortable').attr('id');
			renumberArrayFieldGroups(parentId);
		});
	});

	//Remove Button
	$(onclickParent).on('click', '.field.array .remove-entry .select-popup-button.remove', function(event){
		$(this).closest('.remove-entry').addClass('show-confirmation');
	});

	//Cancel Remove
	$(onclickParent).on('click', '.field.array .remove-entry .select-popup-button.cancel', function(event){
		$(this).closest('.remove-entry').removeClass('show-confirmation');
	});

	//Remove Confirm
	$(onclickParent).on('click', '.field.array .remove-entry .select-popup-button.remove-confirm', function(event) {
		let parentId = $(this).closest('.sortable').attr('id');
		$(this).closest('.array-field-group').remove();
		renumberArrayFieldGroups(parentId);
	});



	//===============================
	// Update title of field group 
	//===============================
	
	$(onclickParent).on('change', '.field.array input.title, .field.array select.title, [alt_array_title="true"]', function(){
		let arrayLabel = getArrayFieldGroupLabel($(this));
		if(arrayLabel == '') arrayLabel = '<span style="font-style: italic">(blank)</span>';
		$(this).closest('.array-field-group').find('> .header > .array-preview > .preview-field').html(arrayLabel);
	});

	$(onclickParent).on('change', '.field.array input:not(.title), .field.array select:not(.title)', function(){
		let arrayField = $(this).closest('.field.array');
		let addButton = arrayField.find('> .value > .select-popup-button.add');
		let addBulkButton = arrayField.find('> .value > .select-popup-button.add-bulk');
		let fieldInfo;
		if(addButton.length) {
			fieldInfo = addButton.attr('field_info');
		} else if(addBulkButton.length) {
			fieldInfo = addBulkButton.attr('field_info');
		}

		console.log(fieldInfo);
		fieldInfo = JSON.parse(atob(fieldInfo));
		console.log(fieldInfo);

		if(fieldInfo.hasOwnProperty('title_template')) {
			let arrayLabel = fieldInfo.title_template;
			let arrayFieldGroup = $(this).closest('.array-field-group');
			let arrayFieldGroupFields = arrayFieldGroup.find('.field');
			let arrayFieldGroupValues = {};

			$(arrayFieldGroupFields).each(function(){
				console.log($(this));
				const fullFieldName = $(this).attr('full_field_name');
				const fieldName = $(this).attr('field_name');
				arrayFieldGroupValues[fieldName] = getArrayFieldGroupLabel($(this).find('[name="' + fullFieldName + '"]'));
			});

			console.log(arrayFieldGroupValues);
			$.each(arrayFieldGroupValues, function(field, value){
				// console.log(i, field);
				if(value === undefined) value = '<em>undefined</em>';
				let re = new RegExp('{{' + field + '}}', "g");
				arrayLabel = arrayLabel.replace(re, value);
			});

			console.log(arrayLabel);

			if(arrayLabel == '') arrayLabel = '<span style="font-style: italic">(blank)</span>';
			$(this).closest('.array-field-group').find('> .header > .array-preview > .preview-field').html(arrayLabel);
		}
	});


	//===============================
	// Drag/Drop Functionality 
	//===============================

	function createDragAndDropForArrays(sortableId) {
		Sortable.create(document.getElementById(sortableId), {
			handle: '.order-number',
			animation: 200,
			onUpdate: function() {
				renumberArrayFieldGroups(sortableId);
			}
		});
	}

	function renumberArrayFieldGroups(parentId) {
		console.log(parentId);
		const selector = '#' + parentId + ' .array-field-group[parent="' + $('#' + parentId).attr('field_name') + '"]:not(.default-value)';
		$(selector).each(function(index){
			$(this).attr('order', index);
			$(this).find('.order-number .number').html(index + 1);

			let nameArray, fullFieldName;
			$(this).find('.field [name]').each(function(){
				let nameArray = $(this).attr('name').split('][');
				nameArray[nameArray.length - 2] = index;
				$(this).attr('name', nameArray.join(']['));

				const datepickerField = $(this).closest('.value').find('input.datepicker');

				if(datepickerField.length) {
					datepickerField.attr('id', nameArray.join(']['));
				}
			});
			$(this).find('.field').each(function(){
				// console.log($(this).attr('full_field_name'));
				if($(this).attr('full_field_name') !== undefined && $(this).attr('full_field_name').length) {
					let fullNameArray = $(this).attr('full_field_name').split('][');
					if(fullNameArray.length > 2) {
						fullNameArray[fullNameArray.length - 2] = index;
						$(this).attr('full_field_name', fullNameArray.join(']['));
					}
				}
			});
		});
	}

	$('.sortable').each(function(){
		createDragAndDropForArrays($(this).attr('id'));
	});

	$(onclickParent).on('change', '.field.array .field [name]', function(e){
		e.stopPropagation();
		const parentArray = $(this).closest('.field.array');
		const valueField = parentArray.find('[name="sc-fields[' + parentArray.attr('field_name') + ']"]');

		const updateValue = btoa(JSON.stringify(getAllArrayValues(parentArray)));
		valueField.val(updateValue).trigger('click');
	});


	function getAllArrayValues(parentArray) {
		const arrayFields = parentArray.find('.field [name]');

		let arrayValues = {};
		arrayFields.each(function(){
			let nameArray = $(this).attr('name').split('][');
			let index = nameArray[nameArray.length - 2];
			let subField = nameArray[nameArray.length - 1].split(']')[0];

			if(!arrayValues.hasOwnProperty(index)) arrayValues[index] = {};

			arrayValues[index][subField] = $(this).val();
		});

		return arrayValues;
	}
});